import { render, staticRenderFns } from "./DialogTenderReplace.vue?vue&type=template&id=24c29f3a"
import script from "./DialogTenderReplace.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderReplace.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports